import Parking from '../../parkings/models/parking';
import ParkingOccupation from './parking-occupation';

class AgendaEntryParking extends Parking {
  parkingOccupations?: ParkingOccupation[];
}

export default AgendaEntryParking;
